import { useMemo } from 'react'

import { useFetchShippingAddress } from '../../../hooks/useFetchShippingAddress'
import { Contact } from '../../../types/contact'
import { CustomerForm } from '../../../types/customerForm'
import { CustomerFormInitialValues } from '../types/customerForm/customerFormInitialValues'
import { getCustomerFormCreatingValues } from '../utils/customerForm/getCustomerFormCreatingValues'
import { getCustomerFormEditingValues } from '../utils/customerForm/getCustomerFormEditingValues'
import { usePredefinedCustomerFormValues } from './usePredefinedCustomerFormValues'

interface UseGetCustomerFormValuesProps {
  customer?: Contact
  initialValues?: CustomerFormInitialValues
}

export const useGetCustomerFormValues = ({ customer, initialValues }: UseGetCustomerFormValuesProps) => {
  const { isLoading: isLoadingPredefinedValues, predefinedCustomerValues } = usePredefinedCustomerFormValues()
  const { shippingAddress, isLoading: isLoadingShippingAddress } = useFetchShippingAddress(customer?.shippingAddressId)

  const isLoading = isLoadingPredefinedValues || isLoadingShippingAddress

  const shouldSetCustomerValues = !!customer

  const customerValues: Partial<CustomerForm> = useMemo(
    () =>
      shouldSetCustomerValues
        ? getCustomerFormEditingValues({ customer, shippingAddress })
        : getCustomerFormCreatingValues({ initialValues, predefinedCustomerValues }),
    [customer, initialValues, predefinedCustomerValues, shippingAddress, shouldSetCustomerValues],
  )

  return { customerValues, isLoading, predefinedCustomerValues }
}
